import { render, staticRenderFns } from "./ProductListItemGroup.vue?vue&type=template&id=54d81c72&scoped=true&"
import script from "./ProductListItemGroup.vue?vue&type=script&lang=js&"
export * from "./ProductListItemGroup.vue?vue&type=script&lang=js&"
import style0 from "./ProductListItemGroup.vue?vue&type=style&index=0&id=54d81c72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d81c72",
  null
  
)

export default component.exports